import React from "react";
import {
  Table,
  TableContainer,
  TableRow,
  TableBody,
  TableHead,
  TableCell,
  Typography,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { fCurrency } from "../../../utils/formatNumber";

const StyledRowResult = styled(TableRow)(({ theme }) => ({
  "& td": {
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },
}));

const PaymentDetails = ({
  fee,
  senderCurrency,
  recieverCurrency,
  balance,
}) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Payment Details
      </Typography>
      <TableContainer sx={{ overflow: "unset" }}>
        <Table>
          <TableHead
            sx={{
              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
              "& th": {
                backgroundColor: "transparent",
                fontSize: "14px",
                fontWeight: 600,
              },
            }}
          >
            <TableRow>
              <TableCell width={40}>#</TableCell>
              <TableCell align="left">Description</TableCell>
              <TableCell width={320} align="right">
                Amount
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody
            sx={{
              "& td": {
                fontWeight: 500,
                color: "#667085",
                fontSize: "14px",
              },
            }}
          >
            <TableRow
              sx={{
                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
              }}
            >
              <TableCell>{1}</TableCell>
              <TableCell align="left">Transfer Amount</TableCell>
              <TableCell align="right">
                {`${fee?.send_amount || 0} ${senderCurrency || ""}`}
              </TableCell>
            </TableRow>
            <TableRow
              sx={{
                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
              }}
            >
              <TableCell>{2}</TableCell>
              <TableCell align="left">Transaction Fee</TableCell>
              <TableCell align="right">
                {`${fee?.transaction_fee || 0} USD`}
              </TableCell>
            </TableRow>
            <TableRow
              sx={{
                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
              }}
            >
              <TableCell>{3}</TableCell>
              <TableCell align="left">Total Fee</TableCell>
              <TableCell align="right">
                {`${fee?.total_fee || 0} USD`}
              </TableCell>
            </TableRow>
            <TableRow
              sx={{
                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
              }}
            >
              <TableCell>{4}</TableCell>
              <TableCell align="left">Exchange Rate</TableCell>
              <TableCell align="right">
                {`${fee?.exchange_rate || 0} ${recieverCurrency || ""}`}
              </TableCell>
            </TableRow>
            <TableRow
              sx={{
                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
              }}
            >
              <TableCell>{5}</TableCell>
              <TableCell align="left">Receiver Gets</TableCell>
              <TableCell align="right">
                {`${fee?.recipient_amount || 0} ${recieverCurrency || ""}`}
              </TableCell>
            </TableRow>
            <StyledRowResult>
              <TableCell colSpan={1} />
              <TableCell colSpan={1} />
              <TableCell align="right">
                <Typography variant="h6">
                  {`Total ${fee?.user_pay || 0} ${senderCurrency || ""}`}
                </Typography>
                {/* <Typography variant="caption" sx={{ color: "text.secondary" }}>
                  *Available Balance {fCurrency(balance || 0)} {senderCurrency}
                </Typography> */}
              </TableCell>
            </StyledRowResult>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PaymentDetails;

